import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 561 1024",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#52c41a",
			d: "M337.63,90.8h-115.26c-13.95,0-24.87,10.98-24.87,25s11.16,25,24.87,25h115.26c13.95,0,24.87-10.98,24.87-25s-10.93-25-24.87-25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#52c41a",
			d: "M479.25,0H80.1C35.75,0,0,35.74,0,80.09v863.81c0,44.35,35.74,80.09,80.1,80.09h399.81c44.35,0,80.1-35.74,80.1-80.09V80.09c0-44.35-36.41-80.09-80.76-80.09ZM86.1,52.95h387.81c15.23,0,27.14,12.58,27.14,27.14v100.68H58.3v-100.68c0-15.22,12.58-27.14,27.8-27.14h0ZM501.05,231.15v534.5H58.3V231.15h442.75ZM473.25,971.05H86.1c-15.22,0-27.14-12.58-27.14-27.14v-128.54h442.09v128.54c0,15.22-12.58,27.14-27.8,27.14h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#52c41a",
			d: "M280,843.2c-27.02,0-49,21.98-49,49s21.98,49,49,49,49-21.98,49-49-21.98-49-49-49Z"
		})
	]
});
export default SvgMobile;
